export const HOME = {
  emergentLink: "home-emergent-link",
};

export const NAV = {
  logo: "nav-logo",
  linkServices: "nav-link-services",
  linkVerification: "nav-link-verification",
  linkPortfolio: "nav-link-portfolio",
  requestAccessBtn: "nav-request-access-btn",
  mobileMenuBtn: "nav-mobile-menu-btn",
};

export const HERO = {
  section: "hero-section",
  headline: "hero-headline",
  subheadline: "hero-subheadline",
  ctaWhatsapp: "hero-cta-whatsapp",
  ctaLearnMore: "hero-cta-learn-more",
  trustBadge: "hero-trust-badge",
  graphic: "hero-graphic",
};

export const HOW = {
  section: "how-section",
  cardVerification: "how-card-credential-verification",
  cardConsultation: "how-card-private-consultation",
  cardDelivery: "how-card-coordinated-delivery",
};

export const PORTFOLIO = {
  section: "portfolio-section",
  verificationWall: "portfolio-verification-wall",
  bottomCta: "portfolio-bottom-cta",
  cardMetabolic: "portfolio-card-metabolic",
  cardTissue: "portfolio-card-tissue",
  cardCognitive: "portfolio-card-cognitive",
  cardEndocrine: "portfolio-card-endocrine",
  cardRecovery: "portfolio-card-recovery",
  cardImmune: "portfolio-card-immune",
};

export const BANNER = {
  section: "private-access-banner",
  ctaRegisterClinic: "banner-register-clinic-btn",
};

export const COMPLIANCE = {
  section: "compliance-section",
};

export const FOOTER = {
  section: "footer-section",
  corporateName: "footer-corporate-name",
  addressBlock: "footer-address-block",
  emailLink: "footer-email-link",
  whatsappLink: "footer-whatsapp-link",
  linkPrivacy: "footer-link-privacy",
  linkTerms: "footer-link-terms",
  linkRefundShipping: "footer-link-refund-shipping",
  linkB2B: "footer-link-b2b",
  disclaimer: "footer-disclaimer",
  copyright: "footer-copyright",
};

export const DIALOGS = {
  requestAccess: "dialog-request-access",
  requestAccessSubmit: "dialog-request-access-submit",
  registerClinic: "dialog-register-clinic",
  registerClinicSubmit: "dialog-register-clinic-submit",
  portal: "dialog-portal",
  portalContactBtn: "dialog-portal-contact-btn",
};
